import { FC, useContext } from 'react';

import { Market, MarketHelpers } from '@playq/services-shared';

import { randomId } from '/helpers';
import AppContext from '/component/Apps/App/AppContext';
import { Target } from '/shared/FilePreview/helpers';

import AppMarket from './AppMarket';
import { AppMarketsList, AppMarketsStyled } from './styles';

const AppMarketsComponent: FC = () => {
  const {
    form,
    appImage,
    marketImages,
    readonly,
    onUpdateValue,
    onFetchMarketImage,
    onSelectAppImage,
    marketValidationSchema,
  } = useContext(AppContext);
  const allMarkets = MarketHelpers.all;

  const handleChangeMarket = (market: Market) => (toggle: boolean, marketId?: string) => {
    const { markets } = form;
    if (toggle && market in markets) {
      delete markets[market];
    } else {
      markets[market] = marketId || '';
    }
    onUpdateValue('markets', markets);
  };

  const handleSelectAppImage = (market?: Market) => {
    if (market) {
      const url = marketImages[market];
      if (url) {
        const urlWithRequiredSearchParams = new URL(url);
        urlWithRequiredSearchParams.searchParams.append(Target.Hash, randomId());
        urlWithRequiredSearchParams.searchParams.append(Target.Type, 'image/jpeg');
        onSelectAppImage({ market, url: urlWithRequiredSearchParams.toString() });
      }
    }
  };

  const marketItems = allMarkets.map((market: Market) => {
    const imageUrl = marketImages[market];

    const imageSelected = appImage && 'market' in appImage && market === appImage.market;

    return (
      <AppMarket
        key={market}
        market={market}
        selected={market in form.markets}
        marketId={form.markets[market]}
        imageUrl={imageUrl}
        imageSelected={!!imageSelected}
        readonly={readonly}
        validationSchema={market in form.markets ? marketValidationSchema : null}
        changeMarket={handleChangeMarket(market)}
        fetchMarketImage={onFetchMarketImage}
        selectMarketImage={handleSelectAppImage}
      />
    );
  });

  return (
    <AppMarketsStyled label='Markets'>
      <AppMarketsList>{marketItems}</AppMarketsList>
    </AppMarketsStyled>
  );
};

export const AppMarkets = AppMarketsComponent;
